/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React from 'react'
import ReactDOM from 'react-dom'
import ErrorBoundary from '../components/error-boundary'
import ChatbotWrapper from './ChatbotWrapper'

const ChatbotComponent = () => {
  const mountId = document.getElementById('chatbot-react-div')

  if (mountId) {
    ReactDOM.render(
      <ErrorBoundary>
        <ChatbotWrapper />
      </ErrorBoundary>,
      mountId
    )
  }
}

export default ChatbotComponent
window.initChatbotComp = ChatbotComponent
